import axios from "axios";
import {
  server,
  apiUrl,
  NOT_CONNECT_NETWORK,
  NETWORK_CONNECTION_MESSAGE,
} from "@/services/constants";
import router from "@/router";

/**
 * httpClientSilent
 * ----------------------------------------------------------------
 * axios instance แยกต่างหาก (ไม่ใช้ global interceptor ของ httpClient.js)
 * ใช้สำหรับ API "เสริม" ที่ถ้า error แล้วไม่ควรพาผู้ใช้เด้งออกจากหน้า
 * เช่น เช็ค outstanding invoice ตอนเปิดหน้า Edit Docket
 *
 * - แนบ token และต่อ apiUrl เหมือน httpClient.js เดิม
 * - 401 -> logout + ไปหน้า login (เหมือนเดิม เพื่อความปลอดภัย)
 * - error อื่น ๆ (404 / 500 ฯลฯ) -> ไม่ redirect, แค่ reject ให้ผู้เรียก catch เอง
 */
const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

const httpClientSilent = axios.create({
  withCredentials: true,
});

httpClientSilent.interceptors.request.use((config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    const userToken = localStorage.getItem(server.TOKEN_KEY);
    if (userToken) {
      config.headers = {
        ...(config.headers || {}),
        "x-access-token": userToken,
        authorization: `Bearer ${userToken}`,
      };
    }
    config.url = apiUrl + "/" + config.url;
  }
  config.timeout = 120000;
  return config;
});

httpClientSilent.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    if (!error.response) {
      return Promise.reject({
        code: NOT_CONNECT_NETWORK,
        message: NETWORK_CONNECTION_MESSAGE,
      });
    }
    if (error.response.status === 401) {
      // เหมือน api.logoff() เดิม
      localStorage.removeItem(server.TOKEN_KEY);
      localStorage.clear();
      router.push("/login").catch(() => {});
    }
    // ไม่ทำ router.push("/") เพื่อไม่ให้เด้งไป dashboard
    return Promise.reject(error);
  },
);

export default httpClientSilent;
